var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.33 0C16.3904 0 17.25 0.859613 17.25 1.92V10.5383C17.25 11.5987 16.3904 12.4583 15.33 12.4583H1.92C0.859613 12.4583 0 11.5987 0 10.5383V1.92C0 0.859613 0.859613 0 1.92 0H15.33ZM15.487 2.05507C15.2988 1.70557 14.8629 1.5748 14.5134 1.76299L8.625 4.93368L2.73659 1.76299C2.38709 1.5748 1.95119 1.70557 1.76299 2.05507C1.5748 2.40458 1.70557 2.84048 2.05507 3.02867L8.28424 6.38284C8.49697 6.49739 8.75303 6.49739 8.96576 6.38284L15.1949 3.02867C15.5444 2.84048 15.6752 2.40458 15.487 2.05507Z",
    fill: "#F8F9FA"
  })));
};
export default SvgMail;